import './style.css'
import Experience from './experience/Experience.js'

new Experience(document.querySelector('canvas.webgl'))
